import { render, staticRenderFns } from "./ui-table.vue?vue&type=template&id=7d4a1efc&scoped=true&"
import script from "./ui-table.vue?vue&type=script&lang=ts&"
export * from "./ui-table.vue?vue&type=script&lang=ts&"
import style0 from "./ui-table.vue?vue&type=style&index=0&id=7d4a1efc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4a1efc",
  null
  
)

export default component.exports